import { jsx as t } from "react/jsx-runtime";
import { NodeViewWrapper as i, NodeViewContent as p } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useEffect as s } from "react";
import { LIST_STYLES as d } from "../../constants/default-styles.mjs";
import { useGetParentCount as n } from "./use-get-parent-count.mjs";
import { getOrderedListStyleType as f } from "./utils/list.mjs";
const c = ({ getPos: o, editor: m, updateAttributes: r }) => {
  const { realDepth: e } = n({ editor: m, getPos: o, nodeName: "orderedList" });
  return s(() => {
    setTimeout(() => {
      r({ depth: e });
    });
  }, [e, r]), /* @__PURE__ */ t(
    i,
    {
      as: "ol",
      style: {
        ...d,
        listStyleType: f(e)
      },
      children: /* @__PURE__ */ t(p, {})
    }
  );
};
export {
  c as CustomOrderedList
};
